import React, { useEffect } from 'react'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRegistroGuest } from 'hooks/useLogin'
import { useHistory } from 'react-router-dom';
import './style.sass'

import { Header } from 'pages/Header'
import ErrorType from 'pages/Error/ErrorType'

import RegistroForm from 'components/LoginRegistro/Registro'
import Loading from 'components/Loading'
import { ErrorBoundary } from 'components/Error/ErrorBoundary'
import RegistroFormGuest from 'components/LoginRegistro/RegistroGuest'


export default function Guest() {
    const history = useHistory()

    // - Codigo de instana para track de pagina 
    // useEffect(() => {
    //     window.ineum('page', 'Register Page');
    //     window.scrollTo(0, 0);
    // }, [])

    const backHistory = () => {
        history.go(-1)
    }

    const {
        dataRegistro,
        reciveDataRegistro,
        // reciveDataRegistroFacebook
    } = useRegistroGuest()

    const { isMobile } = useIsMobile()
    const desktopView = () => document.querySelector('#root').classList.add('desktopView')

    useEffect(() => {
        if (isMobile) {
            if (isMobile === 'desktop') {
                document.querySelector('#root').classList.add('desktopView')
            }
        }
    }, [isMobile])


    return (
        <>
            { dataRegistro.loading && <Loading />}
            <Header type='simple' pageClass={isMobile !== 'desktop' ? 'hidden' : 'registroHeader'} />
            <main>
                {dataRegistro.statusCode !== 500
                    ?
                        <>
                            {!dataRegistro.isLoged &&
                                <section className="loginRegistroPage">
                                    <div className="container">
                                        {// isMobile === 'desktop'
                                            // ?
                                                <h1 className="titleRegistro">Para comprar como invitado, compártenos tu correo electrónico y número de teléfono</h1>
                                            // :
                                            /*    <div className="sectionTitleServicioCliente">
                                                    <button onClick={backHistory}>Crear cuenta</button>
                                                </div> */
                                        }
                                        <ErrorBoundary>
                                            <RegistroFormGuest
                                                dataForm={reciveDataRegistro}
                                                warningMessage={dataRegistro.errorMessage}
                                                urlRedirect={dataRegistro.redir}
                                            //    responseFacebook={reciveDataRegistroFacebook}
                                                isMobile={isMobile}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                </section>
                            }
                        </>
                    :
                        <>
                            <ErrorBoundary>
                                <ErrorType
                                    codeStatus={500}
                                    errorText=""
                                />
                            </ErrorBoundary>
                        </>
                }
            </main>
        </>
    )
}